<template>
    <MultiSelect :options="statusList"
                 :filter="true"
                 v-model="selectedValues"
                 optionLabel="name"
                 optionValue="code"
                 appendTo="self"
                 showClear
                 id="status_code"
                 class="form-control form-control-solid form-control-sm"
                 placeholder="Status"
                 style="display: flex; padding: 0.25rem .75rem">
        <template #option="slotProps">
            <div class="flex align-items-center">
                <div class="text-white font-weight-bold px-5 rounded"
                     :style="{backgroundColor: slotProps.option.color}">
                    {{ slotProps.option.name }}
                </div>
            </div>
        </template>
        <template #value="slotProps">
            <span v-if="slotProps.value && slotProps.value.length" class="text-muted">
                {{ slotProps.value.length }} item(s) selecionado(s)
            </span>
            <span v-else class="text-muted">{{ slotProps.placeholder }}</span>
        </template>
    </MultiSelect>
</template>

<script>
import http from "../../helpers/http";
import MultiSelect from "primevue/multiselect";

export default {
    name: "CalendarInputStatus",
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        defaultSelected: {
            type: Array,
            default: () => ['AG','AR','IA','CO','FI']
        }
    },
    emits: ['change', 'update:modelValue'],
    components: {
        MultiSelect,
    },
    data() {
        return {
            statusList: [],
            selectedValues: []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('change', value);
                this.$emit('update:modelValue', value);
            }
        }
    },
    watch: {
        selectedValues: {
            handler(newValues) {
                // Concatena os valores selecionados com vírgula
                const concatenatedValue = newValues ? newValues.join(',') : '';
                this.value = concatenatedValue;
            },
            immediate: true
        },
        modelValue: {
            handler(newValue) {
                // Converte string de volta para array quando modelValue muda
                if (newValue && typeof newValue === 'string') {
                    this.selectedValues = newValue.split(',').map(item => item.trim()).filter(item => item);
                } else if (!newValue) {
                    this.selectedValues = [];
                }
            },
            immediate: true
        }
    },
    methods: {
        getStatusName(code) {
            const status = this.statusList.find(s => s.code === code);
            return status ? status.name : code;
        },
        getStatusColor(code) {
            const status = this.statusList.find(s => s.code === code);
            return status ? status.color : '#6c757d';
        }
    },
    mounted() {
        http.get(`/status`).then((response) => {
            this.statusList = response.data;
            
            // Se não há modelValue inicial, define os valores padrão
            if (!this.modelValue && this.defaultSelected.length > 0) {
                this.selectedValues = [...this.defaultSelected];
            }
        });
    },
}
</script>

<style>
.p-multiselect.p-multiselect-clearable .p-multiselect-label {
    padding-right: 0.75rem !important;
}
.p-multiselect-trigger {
    margin-right: -14px;
}
.text-muted {
    color: #6c757d;
}
</style>